// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-1cd5a485]{transform:translateZ(1px)}.badge[data-v-1cd5a485]{position:absolute;top:-2px;right:6px;width:6px;height:6px;border-radius:6px;background-color:#e82a2a}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
